  import React, { createContext, useState } from 'react'

export interface ServicesObjectType{
  id?:string
  nameTest:string
}

export const initialStateService = {
  startingDimension:['','',''],
  finishedDimension:['','',''],
  toleranceForMore:'',
  toleranceForLess:'',
  destination:'',
  customerName:'',
  material:'',
  quantity:'',
  deadline:'',
  stepByStep:[],
  format:'',
}

interface ServicesContextProps{
  service:ServicesObjectType | any
  setService:React.Dispatch<React.SetStateAction<ServicesObjectType | null>>
}

export const ServicesContext = createContext<ServicesContextProps>({
  service:null,
  setService:() => {return}
})

export const ServicesProvider:React.FC<any> = ({children}) => {
  const [services, setServices] = useState<ServicesObjectType | null>(null)

  return(
    <ServicesContext.Provider value={{
      service: services,
      setService: setServices
    }}
    >
      {children}
  </ServicesContext.Provider>
  )
}